import { CodedProperty, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useCachedAdminApi } from "../../api/admin-api/useCachedAdminApi";
import { DataHooksQueryKey } from "./DataHooksQueryKey";

export const useDubbings = (): SprintQueryResult<CodedProperty[]> => {
    const { getDubbings } = useCachedAdminApi();

    return useSprintQuery<CodedProperty[]>({
        queryKey: [DataHooksQueryKey.Dubbings],
        queryFn: async (): Promise<CodedProperty[]> => {
            const response = await getDubbings();
            return response.items;
        }
    });
};
